fx.ns("desktop.common.behaviour", class Resize extends shared.Behaviour{

    constructor(mouse, guidelines, model)
    {    
        super(mouse, "resize", model);  

        this.guidelines = guidelines;
        this.model = model;
    }

    static get MARGIN() {
        return 5;
    }
    
    static get ROTATION_MARGIN() { 
        return 5;
    }

    start(event)
    {
        super.start();

        this.element = event.element;
        
        if (!this.element || !this.element.data)
            return;

        this.area = event.area;

        this.anchor = fx.dom.parent(event.originalEvent.target, ".anchor");
        fx.dom.addClass(this.anchor, "active");
        this.target = this.element.node;
        
        this.widthStart = this.element.width
        this.heightStart = this.element.height;

        // problem with getBoundingClientRect when clippath
        // let's diplicate it
        // insert a simple rect
        // and get boundingRect

        let boundingRect;
        // Fix : problem with getBoundingClientRect and clippath
        if (this.element.node.getAttribute('clip-path'))
        {
            let node = this.element.node.cloneNode();
            var rect = document.createElementNS("http://www.w3.org/2000/svg", 'rect');
            rect.setAttributeNS(null, 'x', 0);
            rect.setAttributeNS(null, 'y', 0);
            rect.setAttributeNS(null, 'width', this.element.width);
            rect.setAttributeNS(null, 'height', this.element.height);
            rect.setAttributeNS(null, 'fill', "transparent");
            rect.setAttributeNS(null, 'stroke', "transparent");
            node.appendChild(rect);
            this.element.node.parentNode.appendChild(node);

            boundingRect = node.getBoundingClientRect();

            this.element.node.parentNode.removeChild(node);
        }
        else
            boundingRect = this.element.node.getBoundingClientRect();
        
        
        
        this.centerX = boundingRect.left + (boundingRect.width/2);
        this.centerY = boundingRect.top + (boundingRect.height/2);

        this.targetX = this.element.x;
        this.targetY = this.element.y;

        this.originalAngle = this.element.rotation;

        this.startResizePoint = new Point(event.originalEvent.pageX / this.area.scale  / this.model.zoom.realValue, event.originalEvent.pageY / this.area.scale  / this.model.zoom.realValue);
   
        this.tempMatrix = new Matrix();

        event.originalEvent.preventDefault();

        if (this.guidelines)
            this.guidelines.start(this.element);
    }

    action(event)
    {
        super.action();

        if (!this.element || !this.element.data)
            return;

        event.originalEvent.preventDefault();

    
        // User clicked on Rotate anchor : let's rotate element
        if (fx.dom.hasClass(this.anchor,"rotate"))
        {
            let angle = 90;

            if (fx.dom.hasClass(this.anchor, "bottom"))                    
                angle = 270;
            
            let newangle = fx.graphics.getRotationAngle(this.centerX, this.centerY, event.originalEvent.pageX, event.originalEvent.pageY) + angle ; // 90 if on top
            if (newangle < 0)
                newangle = 360 + newangle;
            
            if ( newangle > - Resize.ROTATION_MARGIN && newangle < Resize.ROTATION_MARGIN)
                newangle = 0;
            else
            if ( newangle > 90 - Resize.ROTATION_MARGIN && newangle < 90 + Resize.ROTATION_MARGIN)
                newangle = 90;
            else
            if ( newangle > 180 - Resize.ROTATION_MARGIN && newangle < 180 + Resize.ROTATION_MARGIN)
                newangle = 180;
            else
            if ( newangle > 360 - Resize.ROTATION_MARGIN && newangle < 360 + Resize.ROTATION_MARGIN)
                newangle = 0;
            else
            if ( (newangle > 270 - Resize.ROTATION_MARGIN && newangle < 270 + Resize.ROTATION_MARGIN) )
                newangle = 270;

            this.rotateElement( this.element.rotation ,  newangle, false, this.anchor );
        }
        else
        {
            let angle = this.element.rotation;

            let containerOriginalMousePoint = this.startResizePoint.clone();
            
            let containerMousePoint = new Point(event.originalEvent.pageX/ this.area.scale / this.model.zoom.realValue, event.originalEvent.pageY/ this.area.scale / this.model.zoom.realValue);
            
            this.tempMatrix.identity();
            this.tempMatrix = this.tempMatrix.rotate(  (angle  * Math.PI / 180) );

            let invMatrix = this.tempMatrix.clone();
            invMatrix.invert();

            let localOriginalMousePoint = invMatrix.transformPoint( containerOriginalMousePoint );
            let localMousePoint = invMatrix.transformPoint( containerMousePoint );

            let resizeWidthDistance;
            let resizeHeightDistance;
            let temp = new Point(0,0);

            let minComponentWidth, minComponentHeight;

            if (this.element.minComponentSize)
            {
                minComponentWidth = this.element.minComponentSize.width;
                minComponentHeight = this.element.minComponentSize.height;
            }
            else
            {
                minComponentWidth = 10 / this.area.scale * this.model.zoom.realValue;
                minComponentHeight = 10 / this.area.scale * this.model.zoom.realValue;
            }

            let side, diagonal;

            if (fx.dom.hasClass(this.anchor,"top-left"))
            {
                diagonal = true;

                if (this.widthStart > this.heightStart)
                {
                    resizeWidthDistance =  localOriginalMousePoint.x - localMousePoint.x;
                    resizeHeightDistance = this.heightStart * (resizeWidthDistance / this.widthStart);
                }
                else
                {
                    resizeHeightDistance = localOriginalMousePoint.y - localMousePoint.y;
                    resizeWidthDistance = this.widthStart * (resizeHeightDistance / this.heightStart);
                }

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((-1) *  (resizeWidthDistance + this.widthStart)) - (-1) *  this.widthStart;
                temp.y = ((-1) * (resizeHeightDistance + this.heightStart)) - (-1) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"middle-left"))
            {
                side = "left";
                resizeWidthDistance =  localOriginalMousePoint.x - localMousePoint.x;
                resizeHeightDistance = 0;

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((-1) *  (resizeWidthDistance + this.widthStart)) - (-1) *  this.widthStart;
                temp.y = ((-0.5) * (resizeHeightDistance + this.heightStart)) - (-0.5) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"bottom-left"))
            {
                diagonal = true;
                
                if (this.widthStart > this.heightStart)
                {
                    resizeWidthDistance =  localOriginalMousePoint.x - localMousePoint.x;
                    resizeHeightDistance = this.heightStart * (resizeWidthDistance / this.widthStart);
                }
                else
                {
                    resizeHeightDistance = localMousePoint.y - localOriginalMousePoint.y;
                    resizeWidthDistance = this.widthStart * (resizeHeightDistance / this.heightStart);
                }

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((-1) *  (resizeWidthDistance + this.widthStart)) - (-1) *  this.widthStart;
                temp.y = ((0) * (resizeHeightDistance + this.heightStart)) - (0) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"middle-bottom") || fx.dom.parent(this.anchor, ".middle-bottom"))
            {
                side = "bottom";

                resizeWidthDistance =  0;
                resizeHeightDistance = localMousePoint.y - localOriginalMousePoint.y;

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((-0.5) *  (resizeWidthDistance + this.widthStart)) - (-0.5) *  this.widthStart;
                temp.y = ((0) * (resizeHeightDistance + this.heightStart)) - (0) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"bottom-right"))
            {
                diagonal = true;

                if (this.widthStart > this.heightStart)
                {
                    resizeWidthDistance =  localMousePoint.x - localOriginalMousePoint.x;
                    resizeHeightDistance = this.heightStart * (resizeWidthDistance / this.widthStart);
                }
                else
                {
                    resizeHeightDistance = localMousePoint.y - localOriginalMousePoint.y;
                    resizeWidthDistance = this.widthStart * (resizeHeightDistance / this.heightStart);
                }

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((0) *  (resizeWidthDistance + this.widthStart)) - (0) *  this.widthStart;
                temp.y = ((0) * (resizeHeightDistance + this.heightStart)) - (0) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"middle-right") || fx.dom.parent(this.anchor,".middle-right"))
            {
                side = "right";

                resizeWidthDistance =  localMousePoint.x - localOriginalMousePoint.x;
                resizeHeightDistance = 0;

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((0) *  (resizeWidthDistance + this.widthStart)) - (0) *  this.widthStart;
                temp.y = ((-0.5) * (resizeHeightDistance + this.heightStart)) - (-0.5) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else if (fx.dom.hasClass(this.anchor,"top-right"))
            {
                diagonal = true;

                if (this.widthStart > this.heightStart)
                {
                    resizeWidthDistance = localMousePoint.x - localOriginalMousePoint.x;
                    resizeHeightDistance = this.heightStart * (resizeWidthDistance / this.widthStart);
                }
                else
                {
                    resizeHeightDistance = localOriginalMousePoint.y - localMousePoint.y;
                    resizeWidthDistance = this.widthStart * (resizeHeightDistance / this.heightStart);
                }

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((0) *  (resizeWidthDistance + this.widthStart)) - (0) *  this.widthStart;
                temp.y = ((-1) * (resizeHeightDistance + this.heightStart)) - (-1) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );

            }
            else if (fx.dom.hasClass(this.anchor,"middle-top"))
            {
                side = "top";

                resizeWidthDistance =  0;
                resizeHeightDistance = localOriginalMousePoint.y - localMousePoint.y;

                if( (this.widthStart + resizeWidthDistance) < minComponentWidth )
                    resizeWidthDistance = minComponentWidth - this.widthStart;

                if( (this.heightStart + resizeHeightDistance) < minComponentHeight )
                    resizeHeightDistance = minComponentHeight - this.heightStart;

                temp.x = ((-0.5) *  (resizeWidthDistance + this.widthStart)) - (-0.5) *  this.widthStart;
                temp.y = ((-1) * (resizeHeightDistance + this.heightStart)) - (-1) * this.heightStart;
                temp = this.tempMatrix.transformPoint( temp );
            }
            else
                return;


            let newWidth = Number(this.widthStart + resizeWidthDistance),
                newHeight = Number(this.heightStart + resizeHeightDistance),
                newX = Number(this.targetX + temp.x),
                newY = Number(this.targetY + temp.y);

           
            if (fx.get("settings").gridmode && angle == 0)
            {
                let nextWidth = newWidth.multipleOf( this.precision );
                let nextHeight = newHeight.multipleOf( this.precision );

                newX -= (nextWidth - newWidth);
                newY -= (nextHeight - newHeight);

                /*newWidth = newWidth.multipleOf( this.precision );
                newHeight = newHeight.multipleOf( this.precision );*/

                newWidth = nextWidth;
                newHeight = nextHeight;

                newX = newX.multipleOf( this.precision );
                newY = newY.multipleOf( this.precision );

                // min
                newWidth = newWidth < this.precision ? this.precision : newWidth;
                newHeight = newHeight < this.precision ? this.precision : newHeight;

                if (this.element.avoidlostBorder)
                {
                    let coordinates = this.avoidLostBorderCoordinates(newX, newY, angle, newWidth, newHeight, this.area, this.element, true);
                    newX = coordinates.left;
                    newY = coordinates.top;
                    newWidth = coordinates.width;
                    newHeight = coordinates.height;
                }
                else
                if (this.element.lockOnlostBorder)
                {
                    // TODO
                }
            }   
            
            if (this.guidelines)
                this.guidelines.check(newX, newY, newWidth, newHeight, angle, this.element);


            let result = this.element.resize(newWidth, newHeight, side);
            if (result)
                this.element.move(newX, newY, angle, false);

        }
    }


    rotateElement( actualAngle , angle, complete, anchor)
    {
        if (fx.get("settings").gridmode)
            angle = angle.multipleOf( fx.get("settings").precision );

        let radVal= Math.PI * actualAngle / 180;

        
        let originX = this.element.width / 2; 
        let originY = this.element.height / 2;

        let targetX = this.element.x;
        let targetY = this.element.y;

        let centerX = targetX + originX * Math.cos(radVal) - originY * Math.sin(radVal);
        let centerY = targetY + originX * Math.sin(radVal) + originY * Math.cos(radVal);

        let rotateValue = Number(angle);

        radVal = Math.PI * rotateValue / 180;
        let newX = centerX - originX * Math.cos(radVal) + originY * Math.sin(radVal);
        let newY = centerY - originX * Math.sin(radVal) - originY * Math.cos(radVal);
        

        if (this.element.lockOnlostBorder)
        {
            let coordinates = this.lockOnLostBorderCoordinates( newX, newY, angle);
            if (coordinates.sides > 1)
                return;

            newX = coordinates.left;
            newY = coordinates.top;
        }
            

        this.element.rotate(newX, newY, angle, complete);
    }


    end()
    {
        super.end();

        if (!this.element || !this.element.data)
            return;

        if (this.guidelines)
            this.guidelines.stop();

        fx.dom.removeClass(this.anchor, "active");

        if (fx.dom.hasClass(this.anchor,"rotate"))
            this.element.rotateEnd();
        else
            this.element.resizeEnd();
    }
});